<template>
  <div
    class="nmz_trailer_swiper"
    @touchstart="touchstart"
    @touchmove="touchmove"
    @touchend="touchend"
  >
    <template v-if="show_type === SHOW_TYPE.M01 && this.data_list.length">
      <img
        class="m01_img"
        :class="!this.change ? 'display-show' : 'display-hide'"
        :src="data_list[this.currentImgIndex].img_preview"
        alt=""
        @click="handlePreImgClick"
      />
      <slick :class="slickClass" ref="slick" :style="slickWrapStyle" :options="slick_options">
        <div
          v-for="(item, index) in data_list"
          class="swipe_item"
          :dataIndex="index"
          :key="index"
          @click="handleItemClick(index)"
        >
          <img
            :style="imgStyle"
            :class="{ img_border: index === currentImgIndex }"
            :data-lazy="item.img"
            @load="imgload(item)"
            src="../../../../static/placeholder.png"
          />
          <div class="img_title" :style="textMainColorStyle">{{ item.title }}</div>
          <div class="show_time" :style="textSubColorStyle">{{ item.show_time }}</div>
          <div class="trailer_button" @click.stop="handelTrailer(index, item)">
            <TrailerButton :trailer="item.trailer" />
          </div>
          <div class="play_icon_wrapper" v-if="item.action_info.url && currentImgIndex === index">
            <img class="play_icon" src="../../../../static/play.svg" />
          </div>
          <div class="icon">
            <CoverIcon :info="item.icon" size="large" />
          </div>
        </div>
      </slick>
    </template>

    <template v-else-if="show_type === SHOW_TYPE.M02">
      <!-- TODO... -->
    </template>

    <template v-else-if="show_type === SHOW_TYPE.M03">
      <!-- TODO... -->
    </template>

    <template v-else-if="show_type === SHOW_TYPE.M04">
      <!-- TODO... -->
    </template>
  </div>
</template>
<script>
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';
import { getJSON } from '../../../api/myaxios';
import click_handler from '../../../tools/mgtv/click';
import handle_action from '../../../tools/mgtv/action';
import CoverIcon from '../CoverIcon';
import TrailerButton from './TrailerButton';
import { SHOW_TYPE, SLICK_CONFIG, DEFAULT_SLICK_OPTION } from './constants';
import { click_event } from '../../../tools/mgtv/analysis';
import addCalendar from '../../../tools/mgtv/calendar';

export default {
  name: 'nmzTrailerSwiper',
  components: {
    Slick,
    CoverIcon,
    TrailerButton
  },
  data() {
    return {
      SHOW_TYPE,
      currentImgIndex: 0,
      imageLoad: {},
      change: false
    };
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      }
    },
    data_list: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  touchStartX: 0,
  touchStartY: 0,
  methods: {
    clearAutoPlayTimer() {
      this.autoPlayTimer && clearInterval(this.autoPlayTimer);
      this.autoPlayTimer = null;
    },
    handelTrailer(id, item) {
      // 不支持取消订阅
      if (item.trailer) {
        return;
      }
      click_handler(
        `订阅提醒-${item.title}`,
        () => {
          // console.log('handelTrailer ', id, item);
          // console.log('gact.is_app ', gact.is_app);
          const addToCalendar = item => {
            addCalendar(
              item.add_calendar_title || `芒果独家订阅:${item.title}`,
              item.add_calendar_remark || '',
              item._show_time,
              10 * 60 * 1000, // 持续时间10分钟
              5 // 提前5分钟提醒
            )
              .then(res => {
                click_event('日历添加成功');
                console.log('addCalendar ok', res);
              })
              .catch(e => {
                click_event('日历添加失败' + e);
                console.log('addCalendar error', e);
              });
          };
          const trailer = item => {
            //https://wiki.imgo.tv/pages/viewpage.action?pageId=5088912
            getJSON('//vipact3.api.mgtv.com/api/v1/act/appointment/make', {
              act_name: this.info.act_name,
              phase: item.id,
              note: item.title,
              ticket: window.$bus.user.ticket
            }).then(res => {
              // console.log('trailer res ', res);
              if (!res) {
                return;
              }
              if (res.ret === 0) {
                item.trailer = true;
                window.$toast('恭喜小主订阅成功～');
                if (item.add_calendar && item._show_time && gact.is_app) {
                  addToCalendar(item);
                }
              } else {
                window.$toast(res.msg);
              }
            });
          };

          trailer(item);
        },
        {
          // TODO: 预约按钮点击动作 目前写死这个规则 后续再调整成可配置的
          need_login: true,
          need_act: false
        }
      );
    },
    handleItemClick(id) {
      console.log('handleItemClick ', id);
      if (this.currentImgIndex === id) {
        this.clickItem(this.data_list[id]);
      } else {
        this.currentImgIndex = id;
        this.change = true
        setTimeout(() => {
          this.change = false
        }, 50)
      }

      this.autoPlay();
    },
    handlePreImgClick() {
      console.log('handlePreImgClick', this.currentImgIndex);
      this.clickItem(this.data_list[this.currentImgIndex]);
    },
    clickItem(item) {
      click_handler(
        `${this.info.act_name_chn}-点击-${item.id}`,
        () => {
          handle_action(item);
        },
        {
          need_act: item.action_info.need_act,
          need_login: item.action_info.need_login,
          need_new_user: item.action_info.need_new_user,
          need_vip_level: item.action_info.need_vip_level
        }
      );
    },
    touchstart(e) {
      this.clearAutoPlayTimer();
      if (gact.is_ios_app) {
        // console.log("touchstart", e, e.touches[0].pageX);
        this.touchStartX = e.touches[0].pageX;
        this.touchStartY = e.touches[0].pageY;
      }
    },
    touchend() {
      this.autoPlay();
    },
    touchmove(e) {
      if (gact.is_ios_app) {
        /**
         * IOS APP中 频道页左右滑动时切换频道,preventDefault之后不会将事件传给webview，我们将左右滑动幅度大的事件屏蔽掉。如果一律屏蔽，会导致上下滑动也被禁止了。
         */
        const pageX = e.touches[0].pageX;
        const pageY = e.touches[0].pageY;
        //水平移动距离>纵向移动距离 判定为横向移动
        const isMoveHorizontal =
          Math.abs(pageX - this.touchStartX) > Math.abs(pageY - this.touchStartY);
        // console.log("touchmove", isMoveHorizontal);
        if (isMoveHorizontal) {
          // console.log("prevent move");
          e.preventDefault && e.preventDefault();
          e.returnValue = false;
          e.stopPropagation && e.stopPropagation();
          // console.log('return false')
          return false;
        }
        console.log('return true');
      }
    },
    autoPlay() {
      this.clearAutoPlayTimer();
      this.show_type === this.SHOW_TYPE.M01 &&
        this.info.config.autoplay &&
        this.data_list.length &&
        (this.autoPlayTimer = setInterval(() => {
          this.currentImgIndex = (this.currentImgIndex + 1) % this.data_list.length;
          this.$refs.slick.goTo(this.currentImgIndex);
        }, DEFAULT_SLICK_OPTION.autoplaySpeed));
    },
    imgload(item) {
      // 小图出来的时候提前加载对应大图，防止大图显示的卡顿现象
      // lazyLoad 开启时 onload会触发两次 第二次是正常的图片
      if(item.img_preview && !this.imageLoad[item.img_preview]) {
        this.imageLoad[item.img_preview] = true
      } else {
        const img = new Image()
        img.src = item.img_preview
      }
    }
  },
  mounted() {
    this.autoPlay();
  },
  destroyed() {
    console.log('nmzTrailerSwiper destroyed...');
    this.clearAutoPlayTimer();
  },
  computed: {
    show_type: function() {
      return this.info.config.show_type || SHOW_TYPE.M01;
    },
    sconfig: function() {
      return SLICK_CONFIG[this.show_type];
    },
    slick_options() {
      return Object.assign({}, DEFAULT_SLICK_OPTION, this.sconfig.slick_option, {
        autoplay: false
      });
    },
    slickClass() {
      return 'slick_wrap skick_wrap_' + this.show_type;
    },
    slickWrapStyle() {
      return this.sconfig.wrapStyle;
    },
    imgStyle() {
      return this.sconfig.imgStyle;
    },
    textMainColorStyle: function() {
      return window.$bus.textMainColorStyle;
    },
    textSubColorStyle: function() {
      return window.$bus.textSubColorStyle;
    }
  }
};
</script>

<style lang="stylus">
@import "../../../share/mixins.styl"
.nmz_trailer_swiper
  position relative
  width 7.5rem
  .slick-slide
    outline none
  .display-show
    transition all .1s ease-in
    opacity 1 !important
    transform scale(1.02)
  .display-hide
    opacity 0 !important
  .m01_img
    width 7.5rem
    height 4.2rem
    display block
    opacity 1
  .m01_img_next
    width 7.5rem
    height 4.2rem
    pointer-events none
    opacity 0
    position absolute
    top 0
  .slick_wrap
    .swipe_item
      position relative
      padding: 0 .08rem
      width: 100%
      outline: none
      .img_border
        border 1px solid #FFC663
      .img_title
        text-align center
        font-size .26rem
        height .4rem
        line-height @height
        margin-top .14rem
        ellipsis()
        @media screen and (min-width: 700px)
          font-size 14PX
      .show_time
        text-align center
        font-size .2rem
        height .28rem
        line-height .28rem
        font-weight: bold
        margin-top .06rem
        ellipsis()
        @media screen and (min-width: 700px)
          font-size 12PX
      .trailer_button
        margin-top: .14rem
      .play_icon_wrapper
        position: absolute;
        top: 1.33rem;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        .play_icon
           display block
           height .76rem
           width .76rem
      .icon
        position absolute
        top .1rem
        right .21rem
</style>
